module.exports = __webpack_public_path__ + "img/rebuild_liao_mob_bg.fbb47bf7.png";